<template>
  <b-navbar-dropdown
    data-test-id="localeSwitch"
    class="locale_switch"
    :label="currentLocale"
    collapsible
    hoverable
  >
    <b-navbar-item
      @click="switchLanguage"
      href="#"
    >
      en
    </b-navbar-item>
    <b-navbar-item
      data-test-id="localeHe"
      @click="switchLanguage"
    >
      he
    </b-navbar-item>
  </b-navbar-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { i18nInstance } from '@/utils/i18n'

const { locale } = useI18n()

const currentLocale = computed(() => locale.value)

const switchLanguage = (e: MouseEvent) => {
  e.preventDefault()
  const target = e.currentTarget as HTMLElement
  const clickedValue = target.textContent?.trim()

  if (clickedValue) {
    i18nInstance.switchLocale(clickedValue)
  }
}
</script>
<style lang="scss">
@use "@/assets/styles/_variables" as vars;

.locale_switch {
  text-transform: uppercase;
}
.navbar .navbar-link:not(.is-arrowless)::after {
	border-color: white;
}
.locale_switch.navbar-item.has-dropdown:focus .navbar-link:not(.is-arrowless)::after,
.locale_switch.navbar-item.has-dropdown:hover .navbar-link:not(.is-arrowless)::after,
.locale_switch.navbar-item.has-dropdown.is-active .navbar-link:not(.is-arrowless)::after{
	border-color: $darkBlue;
}
@media screen and (min-width:1024px){
	.locale_switch .navbar-item{
		color: $darkBlue
	}
}
@media screen and (max-width:1024px){
	.locale_switch .button.is-text {
		color: white
	}
}

</style>
